import dynamic from 'next/dynamic'

export const Receipt = dynamic(() => import('./receipt'))
